import * as React from 'react';
import Stack from '@mui/material/Stack';

import { useListHomeMakersLazyQuery } from '@graphql';
import { showAppLoaderVar } from '@context';
import { Highlight } from '@components';
import { MakerSliders } from './components';

const ONE_HOUR = 60 * 60 * 1000;
const MAKER_LAST_CALL_KEY = 'MAKER_LAST_CALL_KEY';

const MakersPage = () => {
  const [visibleCarousels, setVisibleCarousels] = React.useState<number[]>([]);

  const getLastCallFromStorage = () => {
    const storedLastCall = localStorage.getItem(MAKER_LAST_CALL_KEY);
    return storedLastCall ? parseInt(storedLastCall, 10) : new Date().getTime();
  };

  const [lastCall, setLastCall] = React.useState<number>(getLastCallFromStorage());

  const [getMakers, { data, called, loading, refetch }] = useListHomeMakersLazyQuery({
    onCompleted: ({ homeMakers }) => {
      const now = new Date().getTime();
      setLastCall(now);
      localStorage.setItem(MAKER_LAST_CALL_KEY, now.toString());
    },
  });

  React.useEffect(() => {
    const now = new Date().getTime();
    const timeSinceLastCall = now - lastCall;

    if (loading) {
      showAppLoaderVar(true);
    }
    if (!data?.homeMakers && !called) {
      getMakers();
    } else if (data?.homeMakers) {
      if (timeSinceLastCall > ONE_HOUR) {
        refetch();
        setLastCall(now);
        localStorage.setItem(MAKER_LAST_CALL_KEY, now.toString());
      }
      setTimeout(() => {
        showAppLoaderVar(false);
      }, 300);
    }
  }, [data, loading, called]);

  const handleInView = (index: number) => {
    setVisibleCarousels((prev) => [...new Set([...prev, index, index + 1])]);
  };

  if (!data?.homeMakers) {
    return null;
  }

  return (
    <>
      <Highlight type="maker" />
      <Stack
        spacing={10}
        mt={{ xs: '35vh', sm: '60vh', md: '65vh', lg: '85vh' }}
        zIndex={1}
        sx={{
          overflowY: 'auto',
          height: '100%', // important for the usePreventClickOnScroll to work
        }}
      >
        {data.homeMakers.map((makersCategory, index) => (
          <MakerSliders
            key={makersCategory.id}
            handleInView={handleInView}
            index={index}
            makersCategory={makersCategory}
            visibleCarousels={visibleCarousels}
          />
        ))}
      </Stack>
    </>
  );
};

export default MakersPage;
